/**
 * F-034 — the facts the Terms and Privacy pages depend on, in one place so
 * a change is a one-line edit rather than a hunt through two templates.
 */

/** Monitored mailbox named as the support, correction, and deletion channel. */
export const CONTACT_EMAIL = 'ghoulpool@ghoulishmortals.com';

/** Public hostname the beta runs on. */
export const PROD_DOMAIN = 'ghoulpool.ghoulishmortals.com';

/** The name Ghoulish Mortals operates under legally. */
export const LEGAL_ENTITY = 'Ghoulish Mortals LLC';

/**
 * The "Last updated" date on both pages. Must match POLICY_VERSION in
 * ghoulpool-api's `src/auth/auth.constants.ts` — the API stamps that value
 * onto each new user as the version they accepted, and a mismatch means the
 * stored consent points at text nobody can read. Bump both together.
 */
export const POLICY_VERSION = '2026-10-19';
